import styled from 'styled-components'

import { IconProps } from '.'
import BaseSvg from './BaseSvg'

const StyledIcon = styled(BaseSvg)`
  color: #4f6e91;
`

const AppBuilder = ({ title = 'App Builder', ...rest }: IconProps) => (
  <StyledIcon viewBox="0 0 65 65" title={title} {...rest}>
    <g fill="currentColor" fillRule="nonzero">
      <path d="M13.13,2.48A6.57,6.57,0,0,0,18.8,5.74H41.41A5.85,5.85,0,0,1,46,8.39L58.26,29.65a5.85,5.85,0,0,1,0,5.28L46,56.19a5.87,5.87,0,0,1-4.57,2.64H16.85a5.87,5.87,0,0,1-4.57-2.64L7.7,48.3a3.66,3.66,0,0,0-3.15-1.83H0L7.3,59.05a11.67,11.67,0,0,0,9.55,5.5H41.41A12.25,12.25,0,0,0,51,59.05L63.24,37.79a11.71,11.71,0,0,0,0-11L50.94,5.5A11.69,11.69,0,0,0,41.38,0H12.73A7.67,7.67,0,0,0,13.13,2.48Z" />
      <path d="M34.83,52a1.22,1.22,0,0,1-1.06-.61,1.19,1.19,0,0,1,0-1.22l9-15.44a1.21,1.21,0,0,1,1-.61h6.23a1.22,1.22,0,0,1,1.05,1.84l-9,15.43a1.22,1.22,0,0,1-1.06.61Z" />
      <path d="M25.66,20.58A1.24,1.24,0,0,1,24.59,20l-3.05-5.39a1.22,1.22,0,0,1,1.05-1.82l18.16-.12a1.22,1.22,0,0,1,1.07.62l3.06,5.39a1.22,1.22,0,0,1-1.05,1.82Z" />
      <path d="M31.59,31.26a1.22,1.22,0,0,1-1.07-.64l-2.89-5.27a1.22,1.22,0,0,1,1.07-1.8L47,23.45a1.21,1.21,0,0,1,1.07.61l3,5.22a1.22,1.22,0,0,1,0,1.21,1.2,1.2,0,0,1-1,.61Z" />
      <path d="M12.19,39a1.22,1.22,0,0,1-1.06-.61L8,32.93a1.22,1.22,0,0,1,0-1.21l8.7-15.38a1.22,1.22,0,0,1,2.13,0l3.07,5.47a1.2,1.2,0,0,1,0,1.19L13.25,38.36a1.18,1.18,0,0,1-1.06.62Z" />
      <path d="M18.11,49a1.21,1.21,0,0,1-1.06-.62L14.3,43.49a1.22,1.22,0,0,1,0-1.2L23,26.9a1.22,1.22,0,0,1,2.13,0l2.75,4.85a1.24,1.24,0,0,1,0,1.21L19.17,48.35A1.2,1.2,0,0,1,18.11,49Z" />
      <path d="M22.94,52a1.22,1.22,0,0,1-1.06-.61,1.19,1.19,0,0,1,0-1.22l9-15.44a1.22,1.22,0,0,1,1.06-.61h6.17a1.22,1.22,0,0,1,1,1.84l-9,15.43a1.22,1.22,0,0,1-1.06.61Z" />
    </g>
  </StyledIcon>
)

AppBuilder.needsWork = true
AppBuilder.displayName = 'AppBuilderIcon'
export default AppBuilder
